//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: ['conditionList', 'data', 'onClickDelItem', 'onClickAddCond', 'onClickResetParams', 'onCondChange', 'index', 'gradeList', 'levelList'],
  name: 'conditionItemCell',
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    console.log('dddd', this.data);
  },
  methods: {
    hasPeriod: function hasPeriod() {
      return this.data.hasOwnProperty('period');
    },
    hasType: function hasType() {
      return this.data.hasOwnProperty('type');
    },
    hasOrder: function hasOrder() {
      return this.data.hasOwnProperty('order');
    },
    hasMySelf: function hasMySelf() {
      return this.data.hasOwnProperty('myself');
    },
    hasGrade: function hasGrade(params) {
      return params.hasOwnProperty('grade');
    },
    hasLevel: function hasLevel(params) {
      return params.hasOwnProperty('level');
    },
    hasNew: function hasNew() {
      return this.data.hasOwnProperty('isNew');
    },
    clickAddCondition: function clickAddCondition() {
      this.onClickAddCond(this.index, this.data);
    },
    clickDelItem: function clickDelItem() {
      this.onClickDelItem(this.index, this.data);
    },
    clickResetParams: function clickResetParams() {
      this.onClickResetParams(this.index, this.data);
    },
    condChange: function condChange(value) {
      this.onCondChange(this.index, value);
    }
  }
};